import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReferralHistoryEmptySection from '../empty-section'
import ReferralHistoryListSection from '../list-section'

const ReferralHistoryContent = ({ orderList }) =>
  orderList.length > 0 ? (
    <ReferralHistoryListSection orderList={orderList} />
  ) : (
    <ReferralHistoryEmptySection />
  )

ReferralHistoryContent.propTypes = {
  orderList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default connect((state) => ({
  orderList: state.referralHistory.tabOrderList,
}))(ReferralHistoryContent)
